import { BookedIntervalUnit } from "@app/api/models/Bookings";

export const SlotUnits : BookedIntervalUnit[] = ['hour', 'day', 'week', 'month', 'year'];
